import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import styles from "./index.module.scss";
import Button from "/components/common/button";
import { showPopup } from "../../../../redux/action-creaters/popup";
import { popupTypes } from "../../../../redux/reducers/popupReducer";
import Reviews from "./reviews";
import Questions from "./questions";

const tabs = {
  questions: "questions",
  reviews: "reviews",
};

export default function Communicate() {
  const { product } = useSelector((state) => state.product);

  useEffect(() => {
    setTimeout(() => {
      if (typeof window === "undefined") {
        return;
      }
      Object.values(tabs).forEach((tab) => {
        if (window.location.hash === `#${tab}`) {
          const section = document.getElementById(tab);
          section.click();
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }, 0);
  }, []);

  const [currentTab, setTab] = useState(tabs.questions);

  const dispatch = useDispatch();

  const tabsNames = {
    [tabs.questions]: "Вопросы и ответы",
    [tabs.reviews]: "Отзывы",
  };

  useEffect(() => {
    if (currentTab === tabs.delivery) {
      /* empty */
    }
    if (currentTab === tabs.reviews) {
      if (typeof ym !== "undefined") {
        // eslint-disable-next-line no-undef
        ym(20518312, "reachGoal", "detailPageReviews");
      }
    }
    if (currentTab === tabs.questions) {
      if (typeof ym !== "undefined") {
        // eslint-disable-next-line no-undef
        ym(20518312, "reachGoal", "detailPageQuestions");
      }
    }
  }, [currentTab]);

  const router = useRouter();
  useEffect(() => {
    if (router.query.review) {
      dispatch(
        showPopup(popupTypes.addReview, {
          id: product.ID,
        }),
      );
    }
  }, []);

  const { qestionsAndReviewsCount } = useSelector((state) => state.section);
  const { host } = useSelector((state) => state.params);

  const questions = useMemo(() => {
    return (
      qestionsAndReviewsCount[product.ID]?.[host.split(".")[0]]?.QUESTIONS ||
      qestionsAndReviewsCount[product.ID]?.[""]?.QUESTIONS ||
      0
    );
  }, [qestionsAndReviewsCount]);

  const reviews = useMemo(() => {
    return (
      qestionsAndReviewsCount[product.ID]?.[host.split(".")[0]]?.REVIEWS ||
      qestionsAndReviewsCount[product.ID]?.[""]?.REVIEWS ||
      0
    );
  }, [qestionsAndReviewsCount]);

  return (
    <div className={styles.Info}>
      <div className={styles.Sections}>
        {Object.values(tabs).map((tab) => (
          <span
            onClick={() => {
              setTab(tab);
            }}
            key={tab}
            id={tab}
            className={clsx(currentTab === tab && styles.Selected)}
          >
            {tabsNames[tab]}
            {tab === tabs.reviews && reviews ? ` (${reviews})` : ""}
            {tab === tabs.questions && questions ? ` (${questions})` : ""}
          </span>
        ))}
      </div>
      {currentTab === tabs.reviews && (
        <div>
          {reviews > 0 ? (
            <>
              <Reviews productId={product.ID} />
              <Button
                customStyles={styles.FormButton}
                onClick={() =>
                  dispatch(
                    showPopup(popupTypes.addReview, {
                      id: product.ID,
                    }),
                  )
                }
                label={"Оставить отзыв о товаре"}
              />
            </>
          ) : (
            <div className={styles.Block}>
              <svg
                width="96"
                height="96"
                viewBox="0 0 96 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M49.5 66.5H21.5C19.2909 66.5 17.5 64.7091 17.5 62.5V25.5C17.5 23.2909 19.2909 21.5 21.5 21.5L74.5 21.5C76.7092 21.5 78.5 23.2909 78.5 25.5V39.5"
                  stroke="#9DA4AE"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <circle
                  cx="70"
                  cy="60"
                  r="14.5"
                  stroke="#9DA4AE"
                  strokeWidth="3"
                />
                <rect
                  x="26"
                  y="30"
                  width="3"
                  height="28"
                  rx="1.5"
                  fill="#9DA4AE"
                />
                <rect
                  x="34"
                  y="30"
                  width="3"
                  height="20"
                  rx="1.5"
                  fill="#9DA4AE"
                />
                <rect
                  x="42"
                  y="30"
                  width="3"
                  height="22"
                  rx="1.5"
                  fill="#9DA4AE"
                />
                <rect
                  x="50"
                  y="30"
                  width="3"
                  height="20"
                  rx="1.5"
                  fill="#9DA4AE"
                />
                <rect
                  x="58"
                  y="30"
                  width="3"
                  height="12"
                  rx="1.5"
                  fill="#9DA4AE"
                />
                <rect
                  x="66"
                  y="30"
                  width="3"
                  height="10"
                  rx="1.5"
                  fill="#9DA4AE"
                />
                <path
                  d="M67 56.3333C67 54.4924 68.567 53 70.5 53C72.433 53 74 54.4924 74 56.3333C74 57.8475 72.9399 59.1259 71.488 59.532C70.9561 59.6808 70.5 60.1144 70.5 60.6667V62.5"
                  stroke="#9DA4AE"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <circle cx="70.5" cy="66.5" r="1.5" fill="#9DA4AE" />
              </svg>
              <p>Отзывы пока отсутствуют</p>
              <Button
                customStyles={styles.FormButton}
                onClick={() =>
                  dispatch(
                    showPopup(popupTypes.addReview, {
                      id: product.ID,
                    }),
                  )
                }
                label={"Оставить отзыв о товаре"}
              />
            </div>
          )}
        </div>
      )}

      {currentTab === tabs.questions && (
        <div>
          <>
            {questions > 0 ? (
              <>
                <Questions productId={product.ID} />
                <Button
                  customStyles={styles.FormButton}
                  onClick={() =>
                    dispatch(
                      showPopup(popupTypes.addQuestion, {
                        id: product.ID,
                      }),
                    )
                  }
                  label={"Задать вопрос по товару"}
                />
              </>
            ) : (
              <div className={styles.Block}>
                <svg
                  width="96"
                  height="96"
                  viewBox="0 0 96 96"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.5 66.5H21.5C19.2909 66.5 17.5 64.7091 17.5 62.5V25.5C17.5 23.2909 19.2909 21.5 21.5 21.5L74.5 21.5C76.7092 21.5 78.5 23.2909 78.5 25.5V39.5"
                    stroke="#9DA4AE"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <circle
                    cx="70"
                    cy="60"
                    r="14.5"
                    stroke="#9DA4AE"
                    strokeWidth="3"
                  />
                  <rect
                    x="26"
                    y="30"
                    width="3"
                    height="28"
                    rx="1.5"
                    fill="#9DA4AE"
                  />
                  <rect
                    x="34"
                    y="30"
                    width="3"
                    height="20"
                    rx="1.5"
                    fill="#9DA4AE"
                  />
                  <rect
                    x="42"
                    y="30"
                    width="3"
                    height="22"
                    rx="1.5"
                    fill="#9DA4AE"
                  />
                  <rect
                    x="50"
                    y="30"
                    width="3"
                    height="20"
                    rx="1.5"
                    fill="#9DA4AE"
                  />
                  <rect
                    x="58"
                    y="30"
                    width="3"
                    height="12"
                    rx="1.5"
                    fill="#9DA4AE"
                  />
                  <rect
                    x="66"
                    y="30"
                    width="3"
                    height="10"
                    rx="1.5"
                    fill="#9DA4AE"
                  />
                  <path
                    d="M67 56.3333C67 54.4924 68.567 53 70.5 53C72.433 53 74 54.4924 74 56.3333C74 57.8475 72.9399 59.1259 71.488 59.532C70.9561 59.6808 70.5 60.1144 70.5 60.6667V62.5"
                    stroke="#9DA4AE"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <circle cx="70.5" cy="66.5" r="1.5" fill="#9DA4AE" />
                </svg>

                <p>Вопросы пока отсутствуют</p>
                <Button
                  customStyles={styles.FormButton}
                  onClick={() =>
                    dispatch(
                      showPopup(popupTypes.addQuestion, {
                        id: product.ID,
                      }),
                    )
                  }
                  label={"Задать вопрос по товару"}
                />
              </div>
            )}
          </>
        </div>
      )}
    </div>
  );
}
